import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { useCookieConsent } from '@/providers/CookieConsentProvider';
import { Button } from './ui/button';
import { CookieIcon } from '@radix-ui/react-icons';

export const CookieBanner: React.FC = () => {
  const { showBanner, acceptAll, openPreferences } = useCookieConsent();

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
        >
          <div className="mx-auto max-w-7xl">
            <div className="rounded-lg bg-background/95 shadow-lg ring-1 ring-black/5 backdrop-blur-sm">
              <div className="p-4 sm:p-6">
                <div className="flex items-start gap-4">
                  <div className="hidden sm:block">
                    <CookieIcon className="h-6 w-6 text-muted-foreground" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base font-semibold leading-6 text-foreground">
                      Cookie Consent
                    </h3>
                    <p className="mt-1 text-sm text-muted-foreground">
                      We use cookies to enhance your browsing experience,
                      analyze site traffic, and personalize content. Some
                      features of our site may not work properly without
                      cookies. By clicking "Accept All", you consent to the use
                      of ALL cookies. You can also manage your preferences to
                      control which cookies are set.
                    </p>
                    <p className="mt-2 text-sm text-muted-foreground">
                      For more information, please read our{' '}
                      <a
                        href="/privacy"
                        className="font-medium text-primary hover:underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                      .
                    </p>
                  </div>
                </div>
                <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
                  <Button
                    variant="outline"
                    onClick={openPreferences}
                    className="w-full sm:w-auto"
                  >
                    Manage Preferences
                  </Button>
                  <Button onClick={acceptAll} className="w-full sm:w-auto">
                    Accept All
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
